import React, { useEffect, useRef, useState } from "react";
import styles from "../central.module.css";
import Head from "next/head";
import { useRouter } from "next/router";
import { Link } from "@mui/material";
import MembershipModal from "../../../components/Modal/MembershipModal";
import BlockData from "../../../central-doctraine-json/chapter2.json";
import Common_html from "./Common_html";

export default function Chapter_2() {
  // const corosalref = useRef()

  // useEffect(() => {
  //   if (corosalref.current) {
  //     corosalref.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "nearest",
  //       inline: "start"
  //     })
  //   }
  //   console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])

  const router = useRouter();
  const location = useRouter();
  const { pathname } = location;

  const [membershipOpen, setMembershipOpen] = useState(false);
  const memberfunc = () => {
    setMembershipOpen(true);
  };

  return (
    <>
      <Head>
        <title>Central Doctrine - THE ASPIRANT | School of Our Divine Infinite Being</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
        <meta name="keywords" content="Divine Infinite Being, Central Doctrine, Chapter-II"></meta>
        <meta property="og:title" content="Central Doctrine- Note To The Aspirant"></meta>
        <meta property="og:type" content="website"></meta>
        <meta property="og:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter2_OG_image_Mithun_04-10-2023_v1_new.webp"></meta>
        <meta property="og:image:alt" content="Depiction of a devoted aspirant kneeling before a luminous, divine presence, symbolizing a journey toward spiritual enlightenment. The aspirant is surrounded by celestial symbols and light beams, representing guidance and connection to the Divine Infinite Being."></meta>
        <meta property="og:description" content="In the art and science of Theurgy the imagination is not just a place of fantasy and passing thoughts throughout the day."></meta>
        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta property="og:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=1"></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter2_OG_image_Mithun_04-10-2023_v1_new.webp"></meta>
        <meta property="twitter:image:alt" content="Depiction of a devoted aspirant kneeling before a luminous, divine presence, symbolizing a journey toward spiritual enlightenment. The aspirant is surrounded by celestial symbols and light beams, representing guidance and connection to the Divine Infinite Being."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=1"></meta>
        <meta name="twitter:title" content="Central Doctrine - THE ASPIRANT | The School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="In the art and science of Theurgy the imagination is not just a place of fantasy and passing thoughts throughout the day."></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=2" />
      </Head>

      {/* "block_positioned_image_url": "/image/central-doctrain-new/central_doc_chap2_2nd_img_new.webp" */}

      <Common_html BlockData={BlockData} />

      <MembershipModal membershipOpen={membershipOpen} setMembershipOpen={setMembershipOpen} />
    </>
  );
}
